// Création de l'objet à envoyer au back
const formaterFichierValidationPermisChasser = async (dataForm) => {
    return dataForm.validationPermisChasser && dataForm.numeroGuichetUnique
        ? dataForm.validationPermisChasser[0].getFileToSend()
        : null;
};

export default formaterFichierValidationPermisChasser;
